var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2 9.10335e-07H1.8C0.8073 9.10335e-07 0 0.804601 0 1.7928V12.6072C0 13.5954 0.8073 14.4 1.8 14.4H4.5V18L10.2159 14.4H16.2C17.1927 14.4 18 13.5954 18 12.6072V1.7928C17.9986 1.31651 17.8082 0.860247 17.4708 0.524135C17.1333 0.188023 16.6763 -0.000478003 16.2 9.10335e-07ZM10.8 9.9H4.5V8.1H10.8V9.9ZM13.5 6.3H4.5V4.5H13.5V6.3Z",
    fill: "black",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMessage);
export default __webpack_public_path__ + "static/media/icon_message.61d6f8ac7e9f14b710dbd202824ddda3.svg";
export { ForwardRef as ReactComponent };